import React, { FC, useEffect, useState } from 'react';

import { Table } from '../../common/table/table';
import { useColumns } from './columns';
import { useGuide } from '../../../hooks/use-guide';

const EquipmentsUnitsConditionsTable: FC = () => {
const [units, setUnits] = useState<EntityBase[]>([]);
  const [loading, setLoading] = useState(false);
  const columns = useColumns();

  const fetchGuide = useGuide('equipment_condition', undefined, setLoading);

  useEffect(() => {
    fetchGuide().then(setUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Table
        title="Технические состояния ТО"
        data={units}
        columns={columns}
        loading={loading}
        paper={false}
      />
    </>
  );
};

export default EquipmentsUnitsConditionsTable;
